import { CognitoAuthFlowEnum } from 'modules/auth/useAuth';
import { create } from 'zustand';

export interface AuthUserType {
  cognitoId: string;
  expertId: string;
  email: string;
  authFlow: CognitoAuthFlowEnum;
}

interface AuthStoreType {
  authenticated: boolean;
  user: AuthUserType | null;
  authenticateUser: (user: AuthUserType) => void;
  logoutUser: () => void;
}

export const useAuthStore = create<AuthStoreType>((set) => ({
  authenticated: false,
  user: null,
  authenticateUser: (user: AuthUserType) => set(() => ({ user, authenticated: true })),
  logoutUser: () => set(() => ({ user: null, authenticated: false })),
}));
